import React, { useState } from 'react'
import { useAlert } from '../../../../context/AlertContext';
import { Dialog, DialogActions, DialogContent, IconButton, LinearProgress, Tooltip } from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import holidayServices from '../holidaysServices';

function BusinessHolidayForm({data, callBack }) {
    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [occasion,setOccasion] = useState("");
    const [holidayDate,setHolidayDate] =useState("");
    
    
    

    
    const addNew = ()=>{
        setDialogStatus(true);
    }

    const updateData = ()=>{
        setOccasion(data.occasion);
        setHolidayDate(data.holidayDate)
        setDialogStatus(true);
    }

    const handleClose = () =>{
        setDialogStatus(false)
    }

    const onSubmit = () => {
        const payload = {
          occasion:occasion,
          holidayDate :holidayDate,
        }
        if(data){ //Updating Existing
          payload.id = data.id;
        }
        setSavingStatus(true);
        holidayServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack(res.id)
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    
    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Holiday</button>
                </Tooltip>
            }
            {data &&
                <Tooltip tite="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                            <label className="fform-label fw-bold">HolidayDate</label>
                            <input className='form-control' type="date" value={holidayDate} placeholder='Holiday Date' onChange={(e)=>setHolidayDate(e.target.value)}  />
                        </div>
                        <div className='col-md-12 mb-2'>
                             <label className="form-label fw-bold">Occasion</label>
                            <input className='form-control' type="text" value={occasion} placeholder='Occasion' onChange={(e)=>setOccasion(e.target.value)}  ></input>
                        </div>
                        
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className="row mt-3">
                        <div className='col-md-12'>
                            {savingInProgress ?
                                <LinearProgress/>
                                :
                                <>
                                    <button className="btn btn-primary float-end" onClick={onSubmit} type="button" disabled={occasion===""} >Save</button>
                                    <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                </>
                            }
                        </div>
                        <div className='col-md-12'>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default BusinessHolidayForm